module.exports = __webpack_public_path__ + "img/mo.ba32d0b8.svg";